import { render } from "./AppApplications.vue?vue&type=template&id=25a5d606"
import script from "./AppApplications.vue?vue&type=script&lang=js"
export * from "./AppApplications.vue?vue&type=script&lang=js"

import "./AppApplications.vue?vue&type=style&index=0&id=25a5d606&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__